export const TIMEZONE_FILTER_FIELDS = [
  {
    type: 'text',
    name: 'name',
    label: 'Title',
    value: ''
  },
  {
    type: 'dropdown',
    name: 'visible',
    label: 'Visible',
    value: '',
    options: [
      {
        text: 'Yes',
        value: '1'
      },
      {
        text: 'No',
        value: '0'
      }
    ]
  }
];
